<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="mr-4">
      <a
        class="icon-container"
        href="https://www.facebook.com/ClubWifaqRabat/?locale=fr_FR"
        target="_blank"
      >
        <img :src="require('@/assets/rs_images/facebook.svg')" height="18px" />
      </a>
    </div>
    <div class="mr-4">
      <a
        class="icon-container"
        href="https://www.instagram.com/clubwifaqrabat/?hl=fr"
        target="_blank"
      >
        <img :src="require('@/assets/rs_images/Insta.svg')" height="18px" />
      </a>
    </div>
    <div class="mr-4">
      <a
        class="icon-container"
        href="https://x.com/clubwifaqrabat?lang=fr"
        target="_blank"
      >
        <img :src="require('@/assets/rs_images/x-logo.svg')" height="18px" />
      </a>
    </div>
    <!--<div>
      <a
        class="icon-container"
        href="https://www.tiktok.com/@ezy.officiel"
        target="_blank"
      >
        <img
          :src="require('@/assets/rs_images/tiktok-icon.svg')"
          height="18px"
        />
      </a>
    </div>-->
  </div>
</template>
<script>
export default {
  name: "RSLinks",
};
</script>
<style scoped>
.icon-container:hover img {
  transform: translateY(-2px);
}
</style>
